import { render } from "./PersonalDevelopmentPlan.vue?vue&type=template&id=5dc875e4&scoped=true"
import script from "./PersonalDevelopmentPlan.vue?vue&type=script&lang=js"
export * from "./PersonalDevelopmentPlan.vue?vue&type=script&lang=js"

import "./PersonalDevelopmentPlan.vue?vue&type=style&index=0&id=5dc875e4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5dc875e4"

export default script